<template>
  <div class="main-debug">
    <!-- <vue-draggable-resizable
      axis="y"
      :z="10000"
      style="position:absolute; bottom:220px;right:48px; height:0px;width:0px"
    >
      <div id="debug-button" :style="envStyle" v-show="showMagic">
        <i class="fa fa-smile-beam fa-3x shadow" @click="goToControlCentre" />
      </div>
    </vue-draggable-resizable>-->

    <div class="modal coming-soon-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
      <div class="modal-card">
        <section class="modal-card-body has-text-left">
          <span
            class="is-size-5 has-text-info has-text-weight-semibold"
            @click="closeModal"
          >
            {{ title }}
          </span>
          <span class="is-pulled-right link" @click="toggleCookies">
            {{ buttonName }}
          </span>
          <div class="pre" @click="toggleCookies">
            <div class="code">
              <ul v-if="!isCookies">
                <li v-for="(event, index) in debug" v-bind:key="index">
                  {{ event }}
                </li>
              </ul>
              <ul v-if="isCookies">
                <li v-for="(cookie, index) in cookies" v-bind:key="index">
                  {{ cookie }}
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "MainDebug",
  data() {
    return {
      debug: [],
      cookies: [],
      isCookies: true,
      title: "Console 💻",
      buttonName: "Cookies",
      showArrows: false,
      showMagic: true,
    };
  },
  computed: {
    envStyle() {
      var env = import.meta.env.VITE_TITLE;
      if (env === "Local") return `color:lightgreen`;
      if (env === "Staging") return `color:cyan`;
      return `color:${this.bulmaColor("danger")}`;
    },
  },
  mounted() {
    EventBus.$on("DEBUG", (payload) => {
      this.console("DEBUG", payload);
      this.debug.push(`◉ ${payload}`); //❖◆
    });
    EventBus.$on("DEBUG_ERR", (payload) => {
      this.console("DEBUG_ERR", payload);
      var k = Object.keys(payload)[0]; // only send a single k/v pair in payload obj
      var v = payload[k];
      var less = (({ message, name }) => ({ message, name }))(v);
      var msg = JSON.stringify(less);
      this.debug.push(`❖ ${k}: ${msg}`); //❖◆
    });
    EventBus.$on("OPEN_DEBUG", () => this.openModal());
    EventBus.$on("TOGGLE_MAGIC", () => this.toggleMagic());
    this.toggleCookies();
  },
  methods: {
    openModal() {
      this.printCookies(); // refresh the cookies every time
      this.$el.querySelector(".modal").classList.add("is-active");
    },
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    toggleMagic() {
      this.showMagic = !this.showMagic;
    },
    goToControlCentre() {
      this.showArrows = true;
      setTimeout(() => (this.showArrows = false), 3000);
      if (this.$route.path === "/control") {
        this.goHome();
        return; // already there so go home instead
      }
      this.$router.push("/control").catch((err) => {
        console.error("goToControlCentre err:", err);
        location.reload();
      });
    },
    printCookies() {
      this.cookies = [];
      this.$cookies
        .keys()
        .sort()
        .forEach((k) => {
          var v = JSON.stringify(this.$cookies.get(k)).replace(/"/g, "");
          this.cookies.push(`◆ ${k}: ${v}`); //❖◉
        });
      if (localStorage.store) {
        this.console("localStorage.store", JSON.parse(localStorage.store));
      }
    },
    toggleCookies() {
      this.isCookies = !this.isCookies;
      this.title = "Console 💻";
      this.buttonName = "Cookies";
      if (this.isCookies) {
        this.estimateMemory();
        this.$el.querySelector(".pre").style.backgroundColor = "#2b2b2f";
        this.$el.querySelector(".pre").style.color = "yellow";
        this.title = "Cookies 🍪";
        this.buttonName = "Console";
        this.printCookies();
      } else {
        this.$el.querySelector(".pre").style.backgroundColor = "#f4f4f4";
        this.$el.querySelector(".pre").style.color = "#666";
      }
    },
    // togglePosition() {
    //   // this.goToControlCentre(); // back back
    //   this.$router.go(-1); // go back
    //   this.showArrows = false; // close arrows
    //   this.$el.querySelector("#debug-button").classList.toggle("top");
    //   this.$el.querySelector("#debug-button").classList.toggle("side");
    //   this.closeModal();
    // },
    estimateMemory() {
      this.getCacheStoragesAssetTotalSize();
      if ("storage" in navigator && "estimate" in navigator.storage) {
        navigator.storage.estimate().then((est) => {
          var usage = this.bToMB(est.usage);
          var quota = this.bToMB(est.quota);
          var msg = `Using ${usage} out of ${quota}`;
          this.console(msg);
          EventBus.$emit("DEBUG", msg);
        });
      }
    },
    bToMB(b) {
      return (b / 1048576).toFixed(1) + "MB";
    },
    async getCacheStoragesAssetTotalSize() {
      // Note: opaque (i.e. cross-domain, without CORS) responses in the cache will return a size of 0.
      const cacheNames = await caches.keys();

      let total = 0;

      const sizePromises = cacheNames.map(async (cacheName) => {
        const cache = await caches.open(cacheName);
        const keys = await cache.keys();
        let cacheSize = 0;

        await Promise.all(
          keys.map(async (key) => {
            const response = await cache.match(key);
            const blob = await response.blob();
            total += blob.size;
            cacheSize += blob.size;
          })
        );

        console.log(`Cache ${cacheName}: ${cacheSize} bytes`);
      });

      await Promise.all(sizePromises);

      var mb = this.bToMB(total);
      var msg = `Total Cache Storage: ${mb}`;
      this.console(msg);
      EventBus.$emit("DEBUG", msg);
    },
  },
};
</script>

<style scoped>
.debug-arrows {
  position: absolute;
  bottom: 40vh;
  left: 50vw;
  transform: translate(-50%, 0%);
  width: 80vw;
}
.shadow {
  filter: drop-shadow(2px 2px 2px #333);
}
.side {
  position: absolute;
  bottom: 1px;
  left: 1px;
}
.top {
  position: absolute;
  top: 20px;
  right: 1px;
}
/* .side {
  position: absolute;
  top: 60%;
  left: 25px;
  transform: translate(-50%, -50%);
} */
/* .top {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translate(-50%, -50%);
} */
.pre {
  border-radius: 5px;
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid goldenrod; /* #f36d33;*/
  color: #666;
  page-break-inside: avoid;
  font-size: 12px;
  /* line-height: 1.6; */
  /* margin-bottom: 1.6em; */
  max-width: 100%;
  overflow: auto;
  padding: 1em 0.7em;
  /* display: block; */
  word-wrap: break-word;
}
.code {
  font-family: Monaco, monospace;
  line-height: 120%;
  background-color: rgb(241, 241, 241);
  word-break: normal;
}
.pre .code {
  border: none;
  background: none;
  line-height: 1.3em;
  word-break: break-all;
}
.modal-card-body {
  padding: 12px;
}
</style>